import { useQuery } from 'react-query';
import axios from 'axios';

export const usePickupLocations = () => {
  const { isLoading, error, data, refetch } = useQuery(
    ['pickupLocations'],
    async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/pickup-locations/active`,
        );
        return response.data;
      } catch (err) {
        console.log('Error fetching pickup locations:', err);
        return [];
      }
    },
  );

  const pickupLocations = data || [];

  return {
    pickupLocations,
    pickupLocationsLoading: isLoading,
    pickupLocationsError: error,
    refetchPickupLocations: refetch,
  };
};
